import { render } from "./fileManager.vue?vue&type=template&id=4a972740"
import script from "./fileManager.vue?vue&type=script&lang=js"
export * from "./fileManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__